export enum MouseWheelValue {
  WheelUp = 0,
  WheelDown = 1
}
